import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";
import { trackPageNoResultPage } from "@companion-core/shared/app/tracking/noResultPage";

interface NoResultTrackerProps {
  contentCt: string;
}

export const NoResultTracker = ({ contentCt }: NoResultTrackerProps) => {
  useMountEffect(() => {
    trackPageNoResultPage(contentCt);
  });

  return null;
};
